<template>
  <div
    class="checkout-builder-video-preview embed-responsive"
    :class="`embed-responsive-${ratio}`"
  >
    {{ videoSrc }}
    <iframe :src="videoSrc" class="embed-responsive-item" />
  </div>
</template>

<script>
import { youtubeParser } from "@/functions/helpers";
export default {
  props: {
    component: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ratio() {
      return this.component.config?.ratio;
    },
    videoSrc() {
      return `https://www.youtube.com/embed/${youtubeParser(
        this.component.text
      )}`;
    }
  }
};
</script>
